// ISO 3166-1 alpha-2 country codes with French names.
// Ordered with Algeria first, then the main countries of the Algerian diaspora,
// followed by the rest alphabetically.
export interface Country {
  code: string;
  name: string;
}

export const COUNTRIES: Country[] = [
  { code: 'DZ', name: 'Algérie' },
  { code: 'FR', name: 'France' },
  { code: 'CA', name: 'Canada' },
  { code: 'BE', name: 'Belgique' },
  { code: 'ES', name: 'Espagne' },
  { code: 'IT', name: 'Italie' },
  { code: 'DE', name: 'Allemagne' },
  { code: 'GB', name: 'Royaume-Uni' },
  { code: 'CH', name: 'Suisse' },
  { code: 'US', name: 'États-Unis' },
  { code: 'TN', name: 'Tunisie' },
  { code: 'MA', name: 'Maroc' },
  { code: 'TR', name: 'Turquie' },
  { code: 'AE', name: 'Émirats arabes unis' },
  { code: 'SA', name: 'Arabie saoudite' },
  { code: 'QA', name: 'Qatar' },
  { code: 'NL', name: 'Pays-Bas' },
  { code: 'SE', name: 'Suède' },
  { code: 'AU', name: 'Australie' },
];

export function getCountryName(code?: string | null): string {
  if (!code) return '';
  return COUNTRIES.find((c) => c.code === code)?.name ?? code;
}
